var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeedback = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33337H2.66659C1.93325 1.33337 1.33992 1.93337 1.33992 2.66671L1.33325 14.6667L3.99992 12H13.3333C14.0666 12 14.6666 11.4 14.6666 10.6667V2.66671C14.6666 1.93337 14.0666 1.33337 13.3333 1.33337ZM13.3333 10.6667H3.44659L2.66659 11.4467V2.66671H13.3333V10.6667ZM6.99992 9.33337H11.9999V8.00004H8.33325L6.99992 9.33337ZM9.57325 5.42004C9.70658 5.28671 9.70658 5.08004 9.57325 4.94671L8.39325 3.76671C8.25992 3.63337 8.05325 3.63337 7.91992 3.76671L3.99992 7.68671V9.33337H5.64659L9.57325 5.42004Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeedback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feedback.ff054ad13b61a7fc3b99503d3ab90bd4.svg";